/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuoteSettings
 */
export interface QuoteSettings {
    /**
     * 
     * @type {boolean}
     * @memberof QuoteSettings
     */
    showFeesOnQuote: boolean;
}

/**
 * Check if a given object implements the QuoteSettings interface.
 */
export function instanceOfQuoteSettings(value: object): value is QuoteSettings {
    if (!('showFeesOnQuote' in value) || value['showFeesOnQuote'] === undefined) return false;
    return true;
}

export function QuoteSettingsFromJSON(json: any): QuoteSettings {
    return QuoteSettingsFromJSONTyped(json, false);
}

export function QuoteSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'showFeesOnQuote': json['showFeesOnQuote'],
    };
}

export function QuoteSettingsToJSON(value?: QuoteSettings | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'showFeesOnQuote': value['showFeesOnQuote'],
    };
}

